import React, { FC, ReactNode, useContext } from 'react'

import {
	FloatingPosition,
	Tooltip as MantineTooltip,
	TooltipProps as MantineTooltipProps,
} from '@mantine/core'
import { ClassNameValue } from 'tailwind-merge'
import cn from '../../lib/utils/cn'
import { useOutletContext } from 'react-router-dom'
import { MainLayoutType } from '../layouts/MainLayout'
import AppContext from '../../context/appContext'

interface CustomTooltipProps
	extends Omit<MantineTooltipProps, 'className' | 'label'> {
	children: ReactNode
	className?: ClassNameValue
	classNameChildrenWrapper?: ClassNameValue
	label?: string | ReactNode | null
	isButton?: boolean
	position?: FloatingPosition
}

const Tooltip: FC<CustomTooltipProps> = ({
	className,
	classNameChildrenWrapper,
	children,
	label,
	isButton,
	position = 'top',
	...props
}) => {
	const { isApp } = useContext(AppContext)

	if (!label || isApp) {
		return children
	}

	return (
		<MantineTooltip
			label={label}
			position={position}
			withArrow
			withinPortal={false}
			arrowSize={6}
			arrowRadius={4}
			openDelay={250}
			offset={1}
			classNames={{
				tooltip: cn(
					'absolute bg-text-secondary/90 text-white mx-auto py-1.5 px-3 rounded text-xs text-center whitespace-normal break-words max-w-[180px]',
					className
				),
			}}
			{...props}
		>
			{isButton ? (
				children
			) : (
				<div className={cn('overflow-hidden', classNameChildrenWrapper)}>
					{children}
				</div>
			)}
		</MantineTooltip>
	)
}

export default React.memo(Tooltip)
